//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { TelephoneInformationUpdateItem } from './TelephoneInformationUpdateItem';
import { IEmailUpdate } from './IEmailUpdate';

export class ParentUpdateItem extends ItemBase implements IEmailUpdate {
    Address?: string | null;
    EmailAddress?: string | null;
    FirstName?: string | null;
    LastName?: string | null;
    Note?: string | null;
    PreferredInvoiceRecipient?: boolean;
    SendEmailReminders?: boolean;
    SendSMSReminders?: boolean;
    IncludeInContactList?: boolean;
    TelephoneHome?: TelephoneInformationUpdateItem | null;
    TelephoneMobile?: TelephoneInformationUpdateItem | null;
    TelephoneWork?: TelephoneInformationUpdateItem | null;
    Title?: string | null;

    constructor(initializer?: Partial<ParentUpdateItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "ParentUpdateItem";
}
